<template>
  <div>
    <div class="login-block">
      <div class="bg-image"></div>
      <LoadingSpinner v-if="cargando" />
      <div class="container-login">
        <div class="login-shell">
          <div class="login-sec">
            <div class="login-sec-inner">
              <div class="login-logo-wrap">
                <img
                  src="/img/logos/logo-sos.png"
                  alt="S.O.S Contingencias"
                  class="login-sec-logo"
                />
              </div>

              <h1 class="forgot-title">Recuperar acceso</h1>
              <p class="forgot-subtitle">
                Te enviaremos una contraseña temporal a tu correo.
              </p>

              <form
                class="login-sec-form"
                @submit.prevent="enviarTemporal"
                autocomplete="on"
              >
                <div
                  class="login-field"
                  :class="{
                    'is-invalid': $v.email.$dirty && $v.email.$invalid,
                    'is-valid': $v.email.$dirty && !$v.email.$invalid,
                  }"
                >
                  <span class="login-field__icon" aria-hidden="true">
                    <i class="fas fa-envelope"></i>
                  </span>
                  <input
                    type="email"
                    class="login-field__input"
                    v-model.trim="email"
                    placeholder="Correo electrónico"
                    autocomplete="username"
                    name="email"
                  />
                </div>

                <button
                  type="submit"
                  class="btn-login"
                  :class="{ 'btn-login--ready': !$v.email.$invalid }"
                  :disabled="$v.email.$invalid || cargando"
                >
                  <span
                    v-if="cargando"
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                  ></span>
                  <span v-else>Enviar contraseña temporal</span>
                </button>

                <router-link class="forgot-back" to="/LoginForm">
                  Volver al inicio de sesión
                </router-link>
              </form>

              <div class="login-brand-footer">
                <img
                  src="/img/logos/Logo-Support-7-24.png"
                  alt="Support 7-24"
                  class="login-brand-footer__img"
                />
              </div>
            </div>
          </div>

          <div class="banner-sec">
            <img
              class="banner-sec__img"
              src="/img/fondos/banerinicio3.png"
              alt="Support 7-24"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import axios from "axios";
import LoadingSpinner from "../components/LoadingSpinner";
import { parseLoginError } from "../utils/loginErrors";

export default {
  name: "ForgotPassword",
  components: {
    LoadingSpinner,
  },
  data: () => ({
    email: "",
    cargando: false,
  }),
  validations: {
    email: { required, email },
  },
  methods: {
    mostrarError(text) {
      this.$swal({ icon: "error", title: "Oops...", text });
    },
    async enviarTemporal() {
      if (this.cargando) return;
      this.$v.$touch();
      if (this.$v.$invalid) return;

      this.cargando = true;
      let mensajeOk =
        "Si el correo está registrado, enviamos una contraseña temporal.";
      try {
        await axios.get("/sanctum/csrf-cookie", { timeout: 15000 });
        const { data } = await axios.post(
          "/password/temporary",
          { email: this.email },
          { timeout: 20000 }
        );
        if (data && data.message) {
          mensajeOk = data.message;
        }
      } catch (error) {
        const parsed = parseLoginError(error);
        this.cargando = false;
        this.mostrarError(parsed.message);
        return;
      }

      this.cargando = false;
      await this.$swal({
        icon: "success",
        title: "Revisa tu correo",
        text: mensajeOk,
      });
      this.$router.push({ name: "LoginForm" });
    },
  },
};
</script>

<style>
.login-block {
  width: 100%;
  min-height: 100vh;
  padding: 28px 16px;
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  background: linear-gradient(to bottom right, #153f75, #bad35c);
}

.bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url("../../public/img/fondos/fondo_sos_contingencias.png");
  background-size: cover;
  background-position: center;
  opacity: 0.35;
  pointer-events: none;
}

.container-login {
  position: relative;
  z-index: 1;
  width: min(980px, 94vw);
  max-width: 980px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.22);
  overflow: hidden;
}

.login-shell {
  display: grid;
  grid-template-columns: 38% 62%;
  height: 480px;
  min-height: 480px;
  align-items: stretch;
}

.login-sec {
  display: flex;
  align-items: stretch;
  justify-content: center;
  background: #fff;
  padding: 1.15rem 1.4rem 1rem;
  box-sizing: border-box;
  height: 100%;
}

.login-sec-inner {
  width: 100%;
  max-width: 260px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  min-height: 100%;
  height: 100%;
}

.login-logo-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex: 0 0 auto;
  margin: 0 0 0.2rem;
}

.login-sec-logo {
  display: block;
  width: 120px;
  max-width: 100%;
  height: auto;
}

.forgot-title {
  margin: 0 0 0.25rem;
  width: 100%;
  font-size: 1rem;
  font-weight: 700;
  color: #153f75;
  line-height: 1.25;
}

.forgot-subtitle {
  margin: 0 0 0.85rem;
  width: 100%;
  font-size: 0.74rem;
  color: #6c757d;
  line-height: 1.35;
}

.login-sec-form {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.login-field {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin: 0 0 0.7rem;
  background: #f2f2f2;
  border-radius: 999px;
  border: 1px solid transparent;
  min-height: 40px;
  padding: 0 0.9rem;
}

.login-field.is-invalid {
  border-color: #dc3545;
}

.login-field.is-valid {
  border-color: #28a745;
}

.login-field__icon {
  color: #9aa0a8;
  font-size: 0.82rem;
  width: 1.1rem;
  text-align: center;
  flex: 0 0 auto;
}

.login-field__input {
  flex: 1 1 auto;
  min-width: 0;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  height: 40px;
  padding: 0 0.55rem;
  margin: 0;
  font-size: 0.86rem;
  color: #2b2f36;
  width: 100%;
  text-align: left;
}

.btn-login {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  min-height: 40px;
  margin: 0;
  border: 0;
  border-radius: 10px;
  background: #9fa3a9;
  color: #fff;
  font-weight: 700;
  font-size: 0.72rem;
  letter-spacing: 0.03em;
  text-transform: uppercase;
  transition: background 0.15s ease;
}

.btn-login:disabled {
  opacity: 1;
  cursor: not-allowed;
}

.btn-login--ready {
  background: #153f75;
}

.btn-login--ready:hover:not(:disabled) {
  background: #0f2f58;
}

.forgot-back {
  display: block;
  margin-top: 0.75rem;
  font-size: 0.74rem;
  font-weight: 600;
  color: #153f75;
  text-decoration: none;
}

.forgot-back:hover {
  text-decoration: underline;
  color: #0f2f58;
}

.login-brand-footer {
  margin-top: auto;
  padding-top: 0.85rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
}

.login-brand-footer__img {
  display: block;
  width: 148px;
  max-width: 100%;
  height: auto;
}

.banner-sec {
  position: relative;
  height: 100%;
  overflow: hidden;
  background: #111;
}

.banner-sec__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (max-width: 767.98px) {
  .login-block {
    padding: 16px 12px;
    position: relative;
    height: auto;
  }

  .container-login {
    width: 100%;
    max-width: 420px;
  }

  .login-shell {
    grid-template-columns: 1fr;
    height: auto;
    min-height: 0;
  }

  .login-sec {
    padding: 1rem 1.25rem 1.15rem;
    height: auto;
  }

  .login-sec-inner {
    max-width: 280px;
    height: auto;
  }

  .banner-sec {
    height: 200px;
  }

  .banner-sec__img {
    height: 200px;
  }
}
</style>
